import React from "react";
import {
  Flex,
  Icon,
  Text,
  Box,
  Code,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  useColorModeValue,
  UnorderedList,
  OrderedList,
  ListItem
} from "@chakra-ui/react";
import { MdPerson, MdAutoAwesome, MdAttachFile } from "react-icons/md";
import ReactMarkdown from "react-markdown";

const ChatResponse = ({
  inputOnSubmit,
  outputCode,
  sourcesCode,
  borderColor,
  brandColor,
  textColor,
  gray,
  iconColor,
}) => {
  // const bgBox = useColorModeValue("gray.50", "navy.900");
  const tableStripeBg = useColorModeValue("#432cf321", "#2c528217");

  return (
    <Flex
      className="chatResponseWrapper mb-10 rounded-[20px] bg-clip-border shadow-3xl shadow-shadow-500 bg-gray-200/30 dark:!bg-navy-800 dark:shadow-none"
      direction="column"
      mx="auto"
      w={{ base: "100%", md: "100%", xl: "100%" }}
      maxW="1400px"
      overflowY="auto"
    // color={textColor}
    >
      <Flex
        direction="column"
        w="100%"
        mx="auto"
        display={outputCode ? "flex" : "none"}
        mb={"auto"}
      >
        <div className="p-4">
          {/* query_text in QueryTextField */}
          <Flex className="QueryText" w="100%" align={"center"} mb="10px">
            <Flex
              borderRadius="full"
              justify="center"
              align="center"
              bg={"transparent"}
              border="1px solid"
              borderColor={borderColor}
              me="20px"
              h="40px"
              minH="40px"
              minW="40px"
            >
              <Icon
                as={MdPerson}
                width="20px"
                height="20px"
                color={textColor}
              />
            </Flex>
            <Flex
              p="22px"
              border="1px solid"
              borderColor={borderColor}
              borderRadius="14px"
              w="100%"
              zIndex={"2"}
            >
              <Text
                className="QueryTextField"
                fontWeight="200"
                fontSize={{ base: "sm", md: "md" }}
                lineHeight={{ base: "24px", md: "26px" }}
              >
                {inputOnSubmit}
              </Text>
              {/* <Icon
                cursor="not-allowed"
                as={MdEdit}
                ms="auto"
                width="20px"
                height="20px"
                color={gray}
              /> */}
            </Flex>
          </Flex>

          {/* answer_text in ResponseTextField */}
          <Flex className="ResponseText" w="100%">
            <Flex
              borderRadius="full"
              justify="center"
              align="center"
              bg={"linear-gradient(15.46deg, #4A25E1 26.3%, #7B5AFF 86.4%)"}
              me="20px"
              h="40px"
              minH="40px"
              minW="40px"
            >
              <Icon
                as={MdAutoAwesome}
                width="20px"
                height="200px"
                color="white"
              />
            </Flex>
            <Flex className="flex-1" direction="column" w="100%" zIndex={"2"}>
              <Flex
                className="ResponseTextField"
                w="100%"
                p="20px"
                border="1px solid"
                borderColor={borderColor}
                borderRadius="8px"
                direction="column"
              >
                {typeof outputCode === "string" &&
                  outputCode.startsWith("**Source:") ? (
                  outputCode.split("**Source:").map((section, index) => {
                    if (!section.trim()) return null;
                    const [source, content] = section.split("**\n\n");
                    const isCSV = content.trim().startsWith("```csv");
                    const csvData = isCSV
                      ? content
                        .trim()
                        .replace(/```csv|```/g, "")
                        .split("\n")
                        .filter((row) => row.trim() !== "")
                      : null;

                    // console.log(csvData);

                    return (
                      <Box key={index} mb={4}>
                        <Text fontWeight="bold" mb={2} color={textColor} fontStyle="italic">
                          Source: {source.trim()}
                        </Text>
                        {
                          isCSV && csvData && csvData.length > 0 ? (
                            <Box
                              overflowX="auto"
                              // border="1px solid"
                              borderColor={borderColor}
                              borderRadius="md"
                            // p={4}
                            // bg={bgBox}
                            >
                              <Table
                                variant="simple"
                                size="sm"
                                sx={{
                                  "thead th": { borderTop: "none", borderBottom: "1px solid", borderColor: borderColor },
                                  "tbody tr:last-child td": { borderBottom: "none" }
                                }}
                              >
                                <Thead>
                                  <Tr>
                                    {csvData[0].split(",").map((header, i) => (
                                      <Th
                                        key={i}
                                        fontSize="sm"
                                        textTransform="capitalize"
                                        textAlign="left"
                                        color={textColor}
                                      >
                                        {header.trim()}
                                      </Th>
                                    ))}
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {csvData.slice(1).map((row, i) => (
                                    <Tr key={i} bg={i % 2 === 0 ? "transparent" : tableStripeBg}>
                                      {row.split(",").map((cell, j) => (
                                        <Td
                                          key={j}
                                          fontSize="sm"
                                          textAlign="left"
                                          color={textColor}
                                        >
                                          {(() => {
                                            const trimmed = cell.trim();
                                            const num = Number(trimmed);
                                            // Check if it's a valid number and not an empty string (Number("") is 0)
                                            return !isNaN(num) && trimmed !== ""
                                              ? parseFloat(num.toFixed(4))
                                              : trimmed;
                                          })()}
                                        </Td>
                                      ))}
                                    </Tr>
                                  ))}
                                </Tbody>
                              </Table>
                            </Box>
                          ) : (
                            <Box
                              // p={4}
                              borderRadius="md"
                              fontSize="sm"
                              // border="1px solid"
                              borderColor={borderColor}
                              color={textColor}
                            >
                              <ReactMarkdown
                                components={{
                                  p: ({ node, ordered, index, depth, inline, ...props }) => <Text mb={3} lineHeight="tall" {...props} color={textColor} />,
                                  h1: ({ node, ordered, index, depth, inline, ...props }) => <Text fontSize="xl" fontWeight="bold" mb={3} mt={4} {...props} color={textColor} />,
                                  h2: ({ node, ordered, index, depth, inline, ...props }) => <Text fontSize="lg" fontWeight="bold" mb={2} mt={3} {...props} color={textColor} />,
                                  h3: ({ node, ordered, index, depth, inline, ...props }) => <Text fontSize="md" fontWeight="bold" mb={2} mt={2} {...props} color={textColor} />,
                                  ul: ({ node, ordered, index, depth, inline, ...props }) => <UnorderedList ml={6} mb={4} spacing={2} {...props} color={textColor} />,
                                  ol: ({ node, ordered, index, depth, inline, ...props }) => <OrderedList ml={6} mb={4} spacing={2} {...props} color={textColor} />,
                                  li: ({ node, ordered, index, depth, inline, ...props }) => (
                                    <ListItem
                                      fontSize="sm"
                                      lineHeight="tall"
                                      sx={{
                                        "&::marker": {
                                          color: textColor,
                                        }
                                      }}
                                      {...props}
                                      color={textColor}
                                    />
                                  ),
                                  strong: ({ node, ordered, index, depth, inline, ...props }) => <Text as="strong" fontWeight="bold" {...props} color={textColor} />,
                                }}
                              >
                                {content.trim()}
                              </ReactMarkdown>
                            </Box>
                          )
                        }
                      </Box>
                    );
                  })
                ) : (
                  <Box color={textColor}>
                    <ReactMarkdown
                      components={{
                        p: ({ node, ordered, index, depth, inline, ...props }) => <Text mb={3} lineHeight="tall" {...props} color={textColor} />,
                        h1: ({ node, ordered, index, depth, inline, ...props }) => <Text fontSize="xl" fontWeight="bold" mb={3} mt={4} {...props} color={textColor} />,
                        h2: ({ node, ordered, index, depth, inline, ...props }) => <Text fontSize="lg" fontWeight="bold" mb={2} mt={3} {...props} color={textColor} />,
                        h3: ({ node, ordered, index, depth, inline, ...props }) => <Text fontSize="md" fontWeight="bold" mb={2} mt={2} {...props} color={textColor} />,
                        ul: ({ node, ordered, index, depth, inline, ...props }) => <UnorderedList ml={6} mb={4} spacing={2} {...props} color={textColor} />,
                        ol: ({ node, ordered, index, depth, inline, ...props }) => <OrderedList ml={6} mb={4} spacing={2} {...props} color={textColor} />,
                        li: ({ node, ordered, index, depth, inline, ...props }) => (
                          <ListItem
                            fontSize="sm"
                            lineHeight="tall"
                            sx={{
                              "&::marker": {
                                color: textColor,
                              }
                            }}
                            {...props}
                            color={textColor}
                          />
                        ),
                        strong: ({ node, ordered, index, depth, inline, ...props }) => <Text as="strong" fontWeight="bold" {...props} color={textColor} />,
                      }}
                    >
                      {outputCode}
                    </ReactMarkdown>
                  </Box>
                )}
              </Flex>
              {/* sources in SourcesTextField */}
              <Flex justify="flex-start">
                <Text mt={4} alignItems={"end"} fontSize={12} >
                  Source:
                  <Icon
                    as={MdAttachFile}
                    width="20px"
                    height="20px"
                    color={iconColor}
                    className=" max-h-3 "
                  />
                  <Code
                    pl={2}
                    pr={2}
                    fontSize={12}
                    className="SourcesTextField"
                    children={sourcesCode}
                  />
                </Text>
              </Flex>
            </Flex>
          </Flex>
        </div>
      </Flex >
    </Flex >
  );
};

export default ChatResponse;
